import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchProductSections } from '../../../../actions/product/productSectionList'
import { AppState } from '../../../../reducers'
import { FiltersBar, FilterTextField } from '../../../Utils/Filters/Filter'
import { useTranslation } from 'react-i18next'
import { ProductSectionListState } from '../../../../reducers/product/productSectionList'
import { Button, Stack } from '@mui/material'
import ProductSection from '../../../../models/ProductSection'
import ProductSections from '../ProductSections'

interface Props {
  fullInfo?: boolean
  productSectionList: ProductSectionListState
}

const ProductSectionList: React.FC<Props> = ({ productSectionList }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation('product')
  const [edit,] = useState(false)

  useEffect(() => {
    dispatch(fetchProductSections(history.location.search))
  }, [dispatch, history.location.search, edit])


  const linkToProductSectionEdit = (productSection: ProductSection) => {
    const editUrl = `/admin/productSections/update/${productSection.id}`
    history.push(editUrl, { update: edit })
  }

  return (
    <div>
      <FiltersBar>
        <FilterTextField style={{marginRight:"10px"}} name="code" label={t("code")} />
        <FilterTextField style={{maxWidth:"400px", width:"400px", marginRight:"10px"}} name="description" label={t("description")} />
      </FiltersBar>
      <ProductSections
        rows={(productSectionList.productSections || []).map(s => ({ data: s }))}
        loading={productSectionList.isFetching}
        pagination={productSectionList.pagination || undefined}
        onClickInfo={linkToProductSectionEdit}
      />

      <Stack display="flex" flexDirection='row' justifyContent="space-between" padding="10px">
        <Button aria-label="back" size='large' style={{ textTransform: 'none' }}  onClick={() => history.push('/admin/productSections/create', { title: t('create') })}>
        {`${t('create')}${t('section')}`}
        </Button>
      </Stack>
    </div>
  )
}

const mapStateToProps = (state: AppState) => ({
  productSectionList: state.productSectionList,
})

export default connect(mapStateToProps, null)(ProductSectionList)